module.exports = __webpack_public_path__ + "img/DM.2e14f656.svg";